<template>
  <div>
    <div class="mb-4 text-lg text-center text-white">
      Please enter your details:
    </div>
    <form @submit.prevent="onFormSubmit">
      <div class="w-full mb-4">
        <input
          type="text"
          required
          maxlength="50"
          placeholder="Name*"
          class="w-full px-6 py-3 text-sm font-bold bg-white rounded-md"
          v-model="form.name"
        />
        <div
          v-if="formErrors.name && formErrors.name.length"
          class="px-2 py-1 mt-1 text-sm text-white bg-red-700 rounded"
        >
          {{ formErrors.name[0] }}
        </div>
      </div>
      <div class="w-full mb-4">
        <input
          type="email"
          required
          maxlength="50"
          placeholder="Email ID*"
          class="w-full px-6 py-3 text-sm font-bold bg-white rounded-md"
          v-model="form.email"
        />
        <div
          v-if="formErrors.email && formErrors.email.length"
          class="px-2 py-1 mt-1 text-sm text-white bg-red-700 rounded"
        >
          {{ formErrors.email[0] }}
        </div>
      </div>
      <div class="w-full mb-4">
        <input
          type="tel"
          required
          maxlength="10"
          placeholder="Mobile number*"
          class="w-full px-6 py-3 text-sm font-bold bg-white rounded-md"
          v-model="form.mobile"
          @blur="isValidForm"
        />

        <div
          v-if="formErrors.mobile && formErrors.mobile.length"
          class="px-2 py-1 mt-1 text-sm text-white bg-red-700 rounded"
        >
          {{ formErrors.mobile[0] }}
        </div>
      </div>

      <div class="mb-4">
        <select
          v-model="form.reason"
          class="w-full px-6 py-3 text-sm font-bold bg-white rounded-md"
          required
        >
          <option :value="null" disabled>Reason for refund</option>
          <option
            v-for="(reason, index) in reasons"
            :key="reason"
            :value="index"
          >
            {{ reason }}
          </option>
        </select>
        <div
          v-if="formErrors.reason && formErrors.reason.length"
          class="px-2 py-1 mt-1 text-sm text-white bg-red-700 rounded"
        >
          {{ formErrors.reason[0] }}
        </div>
      </div>

      <div class="mb-4">
        <input
          type="file"
          ref="file"
          name="invoice"
          v-show="false"
          @change="onFileUpload"
        />
        <button
          class="flex items-center justify-center w-full px-6 py-3 text-lg text-white rounded-md bg-blue"
          @click.stop.prevent="$refs.file.click()"
        >
          <span class="flex">
            <img
              src="../assets/images/paperclip.svg"
              alt="paperclip"
              class="mr-2"
            />
            <span v-if="form.invoice && form.invoice.name"
              >{{ form.invoice.name.substr(0, 25) }}
              {{ form.invoice.name.length > 24 ? '...' : '' }}
            </span>
            <span v-else>Attach invoice</span>
          </span>
        </button>
        <div
          v-if="formErrors.invoice && formErrors.invoice.length"
          class="px-2 py-1 mt-1 text-sm text-white bg-red-700 rounded"
        >
          {{ formErrors.invoice[0] }}
        </div>
      </div>
      <label class="mt-4 marketing-optin__label" for="marketingOptin">
        <input
          type="checkbox"
          id="marketingOptin"
          v-model="isTnCAccepted"
          class="marketing-optin__checkbox"
          autocomplete="off"
          name="marketingOptin"
        />
        <span class="checkmark"></span>
        <span class="mandatory">*</span>

        By registering, I agree to P&G or P&G third party agencies, businesses
        or media partners collecting and processing my Name, Mobile Number,
        Email ID, age group, and gender to (i) send me information on all P&G
        brands and their programs, offers, samples, surveys and service via
        call, SMS, email, Whatsapp, social media or other digital platforms for
        all marketing & advertising purposes, and (ii) contacting me for
        auditing/ verifying trial of P&G products. I have read and I agree to
        the P&G Privacy Policy
        <a
          href="https://privacypolicy.pg.com/en-IN/"
          target="_blank"
          rel="noreferrer"
          class="text-white underline"
        >
          www.pg.com/privacy</a
        >
      </label>
      <button
        class="relative w-full px-6 py-3 mb-8 text-lg font-bold text-center text-white rounded-md bg-lightblue"
        type="submit"
        :class="{
          'btn--loading': isFormSubmitting,
          'opacity-25': !isTnCAccepted,
        }"
        :disabled="isFormSubmitting || !isTnCAccepted"
      >
        <span> Submit </span>
      </button>
    </form>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import axios from 'axios'

export default {
  name: 'Form',
  props: {},

  setup(props, { emit }) {
    const reasons = [
      'Battery is not charging properly',
      'Timer is not working properly',
      'Not satisfied with the performance',
      'Any Other Reason',
    ]
    /** form logic */
    const isTnCAccepted = ref(false)
    const isFormSubmitting = ref(false)
    const form = reactive({
      name: null,
      email: null,
      mobile: null,
      reason: null,
      invoice: null,
    })
    const initialErrors = {
      name: [],
      email: [],
      mobile: [],
      reason: [],
      invoice: [],
    }
    let formErrors = ref(initialErrors)

    const onFileUpload = (event) => {
      form.invoice = event.target.files[0]
      isValidForm()
    }
    const onFormSubmit = () => {
      if (isValidForm()) {
        postForm()
      }
    }

    const isValidForm = () => {
      const { mobile, invoice } = form
      formErrors = ref(initialErrors)
      if (!mobile || !new RegExp(/^[6-9]\d{9}$/).test(mobile)) {
        formErrors.value.mobile.push(
          'Please enter a valid 10 digit mobile number',
        )
        return false
      } else {
        formErrors.value.mobile = []
      }

      if (!invoice) {
        formErrors.value.invoice.push('Please select invoice file')
        return false
      } else {
        formErrors.value.invoice = []
      }

      return true
    }

    const getCookie = (name) => {
      const value = '; ' + document.cookie
      const parts = value.split('; ' + name + '=')
      if (parts.length == 2) {
        return parts.pop().split(';').shift()
      }
    }

    const postForm = async () => {
      isFormSubmitting.value = true
      const formData = new FormData()
      Object.keys(form).forEach((key) => {
        formData.append(key, form[key])
      })
      formData.append('invoice', form.invoice)
      try {
        const response = await axios({
          method: 'post',
          url: '/safalta-app/oralb-moneyback/api/submit-entry',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-CSRFToken': getCookie('csrftoken'),
          },
        })
        emit('next')
      } catch (e) {
        const response = e.response
        if (response && response.status === 400) {
          Object.keys(formErrors.value).map((key) => {
            formErrors.value[key] = response.data[key]
          })
        } else {
          alert('An error occurred, Please try again later!')
        }
      }
      isFormSubmitting.value = false
    }

    return {
      isFormSubmitting,
      onFileUpload,
      onFormSubmit,
      formErrors,
      reasons,
      form,
      isValidForm,
      isTnCAccepted,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="postcss">
.btn--loading {
  pointer-events: none;
  & > span {
    visibility: hidden;
  }
  &:before {
    margin: -13px 0 0 -13px;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    content: '';
    background-clip: padding-box;
    border-radius: 24px;
    background-clip: padding-box;
    border: rgba(255, 255, 255, 0.25) 2px solid;
    border-top-color: #fff;
    animation: animation-rotate 750ms linear infinite;
  }
}
@keyframes animation-rotate {
  100% {
    transform: rotate(360deg);
  }
}

.marketing-optin__label {
  color: #fff;
  font-size: 12px;
  font-weight: 200;
  letter-spacing: 0.5px;
  line-height: 1.4;
  padding-left: 30px;
  display: block;
  margin-bottom: 20px;
  position: relative;
}
.marketing-optin__checkbox {
  margin-right: 12px;
  position: absolute;
  left: 4px;
}
.marketing_checkbox {
  color: #fff;
  background-color: #ff0000;
  padding: 4px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  border-radius: 3px;
  width: 20px;
  height: 20px;
}
</style>
